import { useContext } from "react";

import { ThemeContext } from "@/modules/theme/contexts/ThemeContext";

export const useTheme = () => useContext(ThemeContext).theme;
